export type BaseResponse<T> = {
  count: number;
  total_results: number;
  result: T;
};

export type BaseError = {
  error: string;
  error_description?: string;
  message?: string;
  detail?: string;
};

export enum Roles {
  SYSOP = 'sysop',
  CUSTOMER = 'customer',
  TESTER = 'tester',
  ORGADMIN = 'admin',
  RESELLER = 'reseller',
  DEVELOPER = 'developer',
  RESELLEE = 'resellee',
  CONTRIBUTOR = 'contributor'
}
